module.exports = __webpack_public_path__ + "static/media/arrow-right.e244b0fb.cur";